import React from "react";
import "./Taisao.css";

const features = [
  {
    id: 1,
    title: "Tiết kiệm chi phí",
    desc: "Chúng tôi tối ưu mức phí tối đa giúp bạn tiết kiệm so với mức phí mặt bằng chung.",
    icon: "/T1.svg",
  },
  {
    id: 2,
    title: "So với cách rút truyền thống",
    desc: "Chỉ khoảng 110k cho 10tr – tiết kiệm hơn gần 4 lần so với cách rút truyền thống.",
    icon: "/T2.svg",
  },
  {
    id: 3,
    title: "Nhận $ thần tốc",
    desc: "Chỉ từ 5 – 7 phút là tiền sẽ lập tức ting ting vào tài khoản. ",
    icon: "/T3.svg",
  },
  {
    id: 4,
    title: "Hỗ trợ tận tình",
    desc: "Đội ngũ chuyên viên túc trực sẽ có mặt sau 15 – 30 phút để bạn quẹt rút $ mặt.",
    icon: "/T4.svg",
  },
  {
    id: 5,
    title: "Hạn mức tối đa:",
    desc: "Hỗ trợ rút hết hạn mức của thẻ. ",
    icon: "/T5.svg",
  },
  {
    id: 6,
    title: "Tiện lợi và trải nghiệm",
    desc: "Phục vụ 24/24 cả ngoài giờ hành chính, thứ 7 và Chủ nhật. ",
    icon: "/T6.svg",
  },
];

export default function Taisao() {
  return (
    <section className="feature-section">
      <div className="feature-container">
        {/* TITLE */}
        <div className="feature-heading">
          <h2>Tại sao nên chọn dịch vụ của chúng tôi</h2>
          <p id="chuthich1">
            Hiếm có dịch vụ nào toàn diện cả 3 tiêu chí: uy tín – tận tâm - tốc
            độ nhận $ hàng đầu.{" "}
          </p>
        </div>

        {/* GRID */}
        <div className="feature-grid">
          {features.map((item) => (
            <div className="feature-card" key={item.id}>
              <img src={item.icon} alt={item.title} className="feature-icon" />

              <h3>{item.title}</h3>
              <p>{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="hero-cta-wrapper">
        <h4>Liên hệ tư vấn</h4>

        <div className="hero-cta-group">
          <a
            onClick={() => {
              window.dataLayer = window.dataLayer || [];

              window.dataLayer.push({
                event: "goi",
              });
            }}
            href="tel:0941297219"
          >
            Gọi 0941 297 219
          </a>
        </div>
      </div>
    </section>
  );
}
